import { useDispatch } from 'react-redux';
import { removeSingleProductFromList } from './removeSingleProductFromList';
import { globalErrorResponse, isErrorOfType, showNotification } from '../../store/notifications/actions';
import { fetchSelectionlists } from '../../store/orderlist/actions';
import { invalidateSelectionListAggregations } from '../../shop/selectionlists/useSelectionListAggregations';
import { invalidateSelectionListSummary } from './useSelectionListSummary';
import { invalidateSelectionListProducts } from '../../shop/selectionlists/api/useSelectionListProducts';
import { invalidateSelectionListGroupedItems } from './useSelectionListGroupedItems';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export const useRemoveSingleFromList = (listId: string) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    return useMutation(removeSingleProductFromList, {
        onSuccess: (_, context) => {
            dispatch(fetchSelectionlists());
            invalidateSelectionListAggregations(listId).then();
            invalidateSelectionListSummary(listId).then();
            invalidateSelectionListProducts(listId).then();
            invalidateSelectionListGroupedItems(listId).then();
            dispatch(
                showNotification(t('notifications.getMessageFromActionList.remove', { productTitle: context.title }))
            );
        },
        onError: error => {
            if (isErrorOfType(error)) {
                dispatch(globalErrorResponse(error));
            }
        }
    });
};
